export const blockIconsSocialLocationCity = (
	<span className='material-symbols-outlined'>location_city</span>
);
